import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../../../../me'
import type { Collection } from '../collection'

import { getActionsConfig } from './actions'
import { Api } from './api'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  constructor(collection: Collection) {
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'Assistant',
      parent: collection.feature,
      selectors: () => new Selectors(this),
    })
    const meFeature = ngCore.inject(me.Feature)
    const api = ngCore.inject(Api)

    this.registerEffects(
      effects.onSubmitPromptRequest(api, meFeature),
      effects.onSaveEditPrompt(),
      effects.refetchOnSubmitPromptSuccess(collection),
    )
  }
}
